module.exports = __webpack_public_path__ + "img/title.c276543e.svg";